import { useContext } from 'react';
import { HackleContext } from '../components';
import type { Event } from '../models';

export function useTrack(): (event: Event) => void {
  const { hackle } = useContext(HackleContext);

  if (!hackle) {
    return () => {};
  }

  return (event: Event) => {
    hackle?.track(event);
  };
}
